import React, { useState, useEffect } from 'react';
import '../components/css/Modals.css';
import DOMPurify from 'dompurify';
interface JobDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  job: {
    title: string;
    status?: string;
    companyName?: string;
    locations: {
      city: string;
      region: string;
      country: string;
    }[];
    industry?: string;
    description?: string;
    roleDescription?: string;
    responsibilities?: string[];
    skills?: string;
    requirements?: string;
  };
}

const JobDetailsModal: React.FC<JobDetailsModalProps> = ({ isOpen, onClose, job }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={`modal-backdrop ${isClosing ? 'modal-fadeOut' : ''}`} onClick={handleClose}>
      <div
        className={`modal-dialog modal-lg ${isClosing ? 'modal-fadeOut' : ''}`}
        role="document"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content" style={{ textAlign: 'left' }}>
          <div className="modal-header" style={{ textAlign: 'left' }}>
            <h5 className="modal-title" style={{ textAlign: 'left' }}>Job Details</h5>
            <button
              type="button"
              className="close opacity-10"
              onClick={handleClose}
              aria-label="Close"
            >
              <img
                src="/svgs/times.svg"
                alt="Close"
                style={{
                  width: '0.8rem',
                  height: '0.8rem',
                  marginRight: '0.5rem',
                }}
              />
            </button>
          </div>
          <div className="modal-body" style={{ textAlign: 'left' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                textAlign: 'left'
              }}
            >
              <h3 style={{ margin: 0, textAlign: 'left' }}>{job.title}</h3>
              {/* <span className="job-status">{job.status}</span> */}
            </div>
            <div className="job-header-details" style={{ textAlign: 'left' }}>
              <p>
                <strong>Company:</strong>{' '}
                {job.companyName || ''}
              </p>
              <p>
                <strong>Location:</strong>{' '}
                {job.locations && job.locations.length > 0
                  ? `${job.locations[0].city}, ${job.locations[0].region}, ${job.locations[0].country}`
                  : 'Location not specified'}
              </p>
              {/* {job.jobFunction && (
                <p>
                  <strong>Function:</strong> {job.jobFunction}
                </p>
              )} */}
              {job.industry && (
                <p>
                  <strong>Industry:</strong> {job.industry || ''}
                </p>
              )}
            </div>

            {job.description && (
              <>
                <h4>Job Description</h4>
                <p
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.description) }}
                />
              </>
            )}

            {job.roleDescription && (
              <>
                <h4>About the Role</h4>
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.roleDescription) }} />
              </>
            )}

            {job.responsibilities && job.responsibilities.length > 0 && (
              <>
                <h4>Responsibilities</h4>
                <ul>
                  {job.responsibilities.map((resp, index) => (
                    <li key={index} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(resp) }} />
                  ))}
                </ul>
              </>
            )}

            {job.skills && (
              <>
                <h4>Required Skills</h4>
                <ul>
                  {job.skills.split(',').map((skill, index) => (
                    <li key={index}>{skill}</li>
                  ))}
                </ul>
              </>
            )}

            {job.requirements && (
              <>
                <h4>Job Requirements</h4>
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.requirements) }} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsModal;
